module.exports = __webpack_public_path__ + "img/KMC364e.33ca8fae.png";